import { createFileRoute, Outlet } from "@tanstack/react-router";

const Route = createFileRoute("/_authorized/monthly-consents")({
  component: () => <Outlet />,
});

export { Route };
